import React from 'react';
import {Paper, Button, Fade, IconButton} from '@mui/material';
import {Close} from '@mui/icons-material';
import styled from 'styled-components';
import {Typography} from '@fupa/fupa-uikit';
import {BannerContainerStyles} from 'app/components/banner/Banner';

const Teaser = styled.div`
  display: flex;
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 0.5rem;
  margin-top: 0.25rem;
`;

const ImageWrapper = styled.div`
  overflow: hidden;
  border-radius: 1rem;
  width: 4rem;
  height: 4rem;
`;

const GridContainer = styled.div`
  max-width: ${props => props.theme.desktopContentWidth}px;
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
  margin: auto;
  align-items: center;
`;

const AppPromoBanner = ({open, text, primaryAction, onClose, className}) => {
  const PrimaryActionButton = primaryAction ? (
    <Button color='secondary' onClick={primaryAction.action}>
      {primaryAction.label}
    </Button>
  ) : null;

  const Actions = primaryAction ? (
    <GridContainer>
      <Teaser>
        <ImageWrapper>
          <img src='/apple-touch-icon.png' alt='app-icon' width={64} height={64} />
        </ImageWrapper>
        <TextContainer>
          <Typography variant='subheading'>FuPa</Typography>
          <Typography variant='body1'>FuPa GmbH</Typography>
        </TextContainer>
      </Teaser>
      {PrimaryActionButton}
    </GridContainer>
  ) : null;

  return (
    <BannerContainerStyles open={open} className={className}>
      <Fade in={open}>
        <Paper sx={{padding: '1rem'}}>
          <GridContainer>
            <div>
              <Typography variant='subheading'>{text}</Typography>
            </div>
            <IconButton edge='end' onClick={onClose} size='large'>
              <Close color='action' />
            </IconButton>
          </GridContainer>
          <p />
          {Actions}
        </Paper>
      </Fade>
    </BannerContainerStyles>
  );
};

export {AppPromoBanner};
